import { useRef, useCallback, useEffect } from 'react';

const useLayout = (list) => {
	const listRef = useRef();
	const containerRef = useRef();

	const listCount = useRef();
	const currentItem = useRef(1);
	const containerWidth = useRef();

	const nextButtonRef = useRef();
	const prevButtonRef = useRef();

	useEffect(() => {
		if (list?.length > 1) {
			listCount.current = list.length;

			setTimeout(() => {
				handleResize();
			}, 100);

			window.addEventListener('resize', handleResize);
		}

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, [list]);

	const fixWidth = useCallback(() => {
		listRef.current.style.width = `${containerWidth.current * list.length}px`;

		const children = listRef.current.children;
		for (let i = 0; i < children.length; i++) {
			children[i].style.width = `${containerWidth.current}px`;
		}
	}, [list]);

	const handleResize = useCallback(() => {
		if (containerRef.current) {
			containerWidth.current = containerRef.current.offsetWidth;
			fixWidth();
			checkDisableButton();
		}
	}, [fixWidth]);

	const onMove = useCallback((count) => {
		const newItem = currentItem.current + count;

		if (newItem <= listCount.current && newItem >= 1) {
			currentItem.current += count;
			listRef.current.style.transform = `translateX(-${
				containerWidth.current * (currentItem.current - 1)
			}px)`;

			checkDisableButton();
		}
	}, []);

	const checkDisableButton = useCallback(() => {
		if (currentItem.current + 1 <= listCount.current) {
			nextButtonRef.current.removeAttribute('disabled');
		} else {
			nextButtonRef.current.disabled = true;
		}

		if (currentItem.current - 1 >= 1) {
			prevButtonRef.current.removeAttribute('disabled');
		} else {
			prevButtonRef.current.disabled = true;
		}
	}, []);

	return {
		listRef,
		containerRef,
		onNext: () => onMove(1),
		onPrev: () => onMove(-1),
		nextButtonRef,
		prevButtonRef,
	};
};

export default useLayout;
